export const Identification = () => {
    return(<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_6630_56645)">
    <path d="M18.9999 14H23.9999" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M18.9999 18H23.9999" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M26.9999 6H4.99994C4.44765 6 3.99994 6.44772 3.99994 7V25C3.99994 25.5523 4.44765 26 4.99994 26H26.9999C27.5522 26 27.9999 25.5523 27.9999 25V7C27.9999 6.44772 27.5522 6 26.9999 6Z" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M11.9999 18C13.6568 18 14.9999 16.6569 14.9999 15C14.9999 13.3431 13.6568 12 11.9999 12C10.3431 12 8.99994 13.3431 8.99994 15C8.99994 16.6569 10.3431 18 11.9999 18Z" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M7.99994 21C8.44369 19.275 10.1362 18 11.9999 18C13.8637 18 15.5574 19.2737 15.9999 21" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </g>
    <defs>
    <clipPath id="clip0_6630_56645">
    <rect width="32" height="32" fill="white"/>
    </clipPath>
    </defs>
    </svg>
    )
}